module.exports = __webpack_public_path__ + "static/media/post-img.5b6d70d0.jpg";